import React from 'react';
import { TableComponents } from 'components'
import { columns } from './components/Columns';
const BusinessCallbackUri = (props) => {


  const getData = async () => {
    return await props.data
  }
  return (

    <TableComponents
      data={getData}
      columns={columns()}
      showPagination={false}
      onChange={() => {
        return getData()
      }}
    />
  );
};

export default BusinessCallbackUri;
